import * as React from "react";
interface props {
  className?: string;
}

const ConnectivitySvg = ({ className }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    // width="70"
    // height="70"
    className={className}
    fill="none"
    viewBox="0 0 70 70"
  >
    <path
      fill="#FF752C"
      d="M32.234 1.8c-.077-.927.613-1.746 1.543-1.779A35 35 0 1 1 14.755 6.45c.76-.538 1.804-.306 2.306.479.5.784.268 1.822-.488 2.365a31.63 31.63 0 1 0 17.484-5.909c-.93.028-1.745-.656-1.823-1.584"
    ></path>
    <path
      fill="#A1A0A0"
      d="M48.125 29.75v2.625a.875.875 0 1 1-1.75 0V29.75a.875.875 0 1 1 1.75 0m-25.375-.875a.875.875 0 0 0-.875.875v2.625a.875.875 0 1 0 1.75 0V29.75a.875.875 0 0 0-.875-.875M44.625 28v15.75a1.75 1.75 0 0 1-1.75 1.75h-1.75a1.75 1.75 0 0 1-1.75-1.75v-.875h-8.75v.875a1.75 1.75 0 0 1-1.75 1.75h-1.75a1.75 1.75 0 0 1-1.75-1.75V28a3.5 3.5 0 0 1 3.5-3.5h12.25a3.5 3.5 0 0 1 3.5 3.5m-12.25 9.188a1.313 1.313 0 1 0-2.626 0 1.313 1.313 0 0 0 2.626 0m7.875 0a1.313 1.313 0 1 0-2.626 0 1.313 1.313 0 0 0 2.626 0m2.625-8.313h-15.75v4.375h15.75z"
    ></path>
  </svg>
);

export default ConnectivitySvg;
